import { Fragment } from "react";
import logo from "../../../media/logo.svg";
import "./header.scss";
import { Link } from "react-router-dom";
import useTrackWebContext from "../../../hooks/useTrackWebContext";

const Header = () => {
  const { finishSession } = useTrackWebContext();
  return (
    <Fragment>
      <header>
        <nav className="flex items-center justify-between relative pt-6 mx-8">
          <Link to="/">
            <img
              className="top-6 w-[195px] h-[45px]"
              src={logo}
              alt="Club La Voz"
            />
          </Link>
          <div className="mx-1 md:flex right-6 items-center pb-1 ">
            <button
              onClick={finishSession}
              className="w-40 p-1 h-8 border border-clvblue font-bold text-sm text-clvblue rounded-full hover:bg-clvblue hover:border-none hover:text-gray-50"
            >
              Cerrar sesión
            </button>
          </div>
        </nav>
      </header>
    </Fragment>
  );
};

export default Header;
